import { Status } from '@dreryk/egabinet-waitlist-frontend-api';

import { createInterpolatedTranslationKey, TranslateFunction } from '@dreryk/react-common';
import {
   FilterPanel,
   FilterPanelControllerCodecConfigArray,
   FilterPanelControllerDeselectorsPropsMapper,
} from '@dreryk/react-components';

import { translationKeys } from '../../../translations';
import { WaitlistFilterPanelSearchParam } from '../../WaitlistFilterPanel.types';

export const STATUSES: Status[] = ['PENDING', 'REGISTERED', 'CONFIRMED', 'COMPLETED', 'SUSPENDED', 'REMOVED'];

const STATUS_TO_SEARCH_PARAM: Record<Status, number> = {
   PENDING: 0,
   REGISTERED: 1,
   CONFIRMED: 2,
   COMPLETED: 3,
   SUSPENDED: 4,
   REMOVED: 5,
};

export const createStatusTriggerLabelExtractor = (
   translate: TranslateFunction
): ((chosenStatuses: Status[]) => string) => {
   return (chosenStatuses) => {
      if (chosenStatuses.length === 1) {
         return translate(translationKeys.statusDescription[chosenStatuses.at(0)!]);
      }
      return translate(
         createInterpolatedTranslationKey(translationKeys.chosenOptions, {
            count: chosenStatuses.length,
            totalCount: STATUSES.length,
         })
      );
   };
};

export const statusesCodec: FilterPanelControllerCodecConfigArray<Status> = {
   type: 'array',
   items: STATUSES,
   keyGenerator: (status) => STATUS_TO_SEARCH_PARAM[status],
};

export const statusesDeselectorsPropsMapper: FilterPanelControllerDeselectorsPropsMapper<
   Status[],
   WaitlistFilterPanelSearchParam.STATUS
> = (currentStatuses) => {
   return currentStatuses.map((status) => ({
      targetValue: currentStatuses.filter((currentStatus) => currentStatus !== status),
      label: translationKeys.statusDescription[status],
      testId: `status-${status}`,
   }));
};

export const statusDeserializer = (currentParamValue: string | null): Status[] => {
   return FilterPanel.paramToArray(
      currentParamValue,
      'number',
      (item) => STATUSES.find((status) => STATUS_TO_SEARCH_PARAM[status] === item)!
   );
};
